import { render, staticRenderFns } from "./CobranzaImport.vue?vue&type=template&id=79429527&scoped=true"
import script from "./CobranzaImport.vue?vue&type=script&lang=js"
export * from "./CobranzaImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79429527",
  null
  
)

export default component.exports